<script lang="ts">
	import { About, Cta, Focus, Hero, Verify } from '$lib/components';

	let { data } = $props();
</script>

<svelte:head>
	<title>{data.site.home.title}</title>
	<meta name="description" content={data.site.home.metaDescription} />
	<meta property="og:title" content={data.site.home.title} />
	<meta property="og:description" content={data.site.home.ogDescription} />
	<meta property="og:url" content={data.site.urls.home} />
</svelte:head>

<main id="main">
	<Hero site={data.site} />
	<About site={data.site} />
	<Focus />
	<Verify site={data.site} />
	<Cta site={data.site} latestNote={data.latestNote} />
</main>
